module.exports = __webpack_public_path__ + "static/media/mollo_25.5a51508e.png";